import { render, staticRenderFns } from "./suppliersToUpdatedTable.vue?vue&type=template&id=563b5f83&"
import script from "./suppliersToUpdatedTable.vue?vue&type=script&lang=js&"
export * from "./suppliersToUpdatedTable.vue?vue&type=script&lang=js&"
import style0 from "./suppliersToUpdatedTable.vue?vue&type=style&index=0&id=563b5f83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports